import { get } from '@/libs/axios'
export default {
  namespaced: true,
  state: {
    qccData: []
  },
  mutations: {
    SET_QCCDATA(state, payload) {
      state.qccData = payload
    }
  },
  actions: {
    // 获取企查查接口数据
    getQccData({ commit }, payload) {
      get('/business/litigation?caseId=' + payload).then((res) => {
        if (res.code === 0 && res.data) {
          commit('SET_QCCDATA', res.data)
        }
      }).catch((error) => {
        console.error(error)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/qcc.js